import { useSelector, useDispatch } from "react-redux";
import useLangTranslation from "./languageProvider";
// import { AlertModal } from "../../setup/alert/swalAlert";
// import { alertIconType } from "../../setup/alert/iconTypes";
import { setErrorInfo } from "../pages/AxiosRtk/successMessage";

function useSubscription() {
    const { subscription, trialPeriod: trialPeriodData } = useSelector(({ settings }) => settings);
    const { getLangTranslation } = useLangTranslation();
    const dispatch = useDispatch();

    function isSubscriptionExpired() {
        if (subscription && subscription?.daysRemaining <= 0 &&
            subscription?.lastDayHours <= 0 &&
            subscription?.lastMinutes <= 0) {
            return true;
        }

        return false;
    }

    function noSubscriptionIsTrialPeriodExpired() {
        if (!subscription && trialPeriodData && trialPeriodData?.secondRemaining <= 0) {
            return true;
        }

        return false;
    }

    function isSubscriptionCardDetailLoding() {
        if (!subscription || (subscription === 'DATA_NOT_FOUND' && trialPeriodData === null)) {
            return true;
        }
        return false
    }

    function getSubscriptionDetails() {
        if (subscription?.daysRemaining <= 0 && subscription?.lastDayHours <= 0 && subscription?.lastMinutes > 0) {
            return getLangTranslation("SUBSCRIPTION_DAYS_HOURS_LEFT_IN_MEMBERSHIP", "$REMAINING_DAYS$ day(s) $REMAINING_HOURS$ hour(s) $REMAINING_MINUTES$ minutes(s) left in the membership")?.replace("$REMAINING_DAYS$", "0")?.replace("$REMAINING_HOURS$", "0")?.replace("$REMAINING_MINUTES$", subscription?.lastMinutes)
        } else if (subscription?.daysRemaining <= 0 && subscription?.lastDayHours > 0) {
            return getLangTranslation("SUBSCRIPTION_DAYS_HOURS_LEFT_IN_MEMBERSHIP", "$REMAINING_DAYS$ day(s) $REMAINING_HOURS$ hour(s) $REMAINING_MINUTES$ minutes(s) left in the membership")?.replace("$REMAINING_DAYS$", "0")?.replace("$REMAINING_HOURS$", subscription?.lastDayHours)?.replace("$REMAINING_MINUTES$", subscription?.lastMinutes)
        } else if (subscription?.daysRemaining > 0) {
            return getLangTranslation("SUBSCRIPTION_DAYS_HOURS_LEFT_IN_MEMBERSHIP", "$REMAINING_DAYS$ day(s) $REMAINING_HOURS$ hour(s) $REMAINING_MINUTES$ minutes(s) left in the membership")?.replace("$REMAINING_DAYS$", subscription?.daysRemaining)?.replace("$REMAINING_HOURS$", subscription?.lastDayHours)?.replace("$REMAINING_MINUTES$", subscription?.lastMinutes)
        } else {
            return getLangTranslation('SUBSCRIPTION_NOT_EXIST', 'Subscription does not exist!')
        }
    }

    function getTrialDataDetails() {
        if (trialPeriodData?.daysRemaining <= 0 && trialPeriodData?.lastDayHours <= 0 && trialPeriodData?.lastMinutes > 0) {
            return getLangTranslation("SUBSCRIPTION_DAYS_HOURS_LEFT_IN_MEMBERSHIP", "$REMAINING_DAYS$ day(s) $REMAINING_HOURS$ hour(s) $REMAINING_MINUTES$ minutes(s) left in the membership")?.replace("$REMAINING_DAYS$", "0")?.replace("$REMAINING_HOURS$", "0")?.replace("$REMAINING_MINUTES$", trialPeriodData?.lastMinutes)
        } else if (trialPeriodData?.daysRemaining <= 0 && trialPeriodData?.lastDayHours > 0) {
            return getLangTranslation("SUBSCRIPTION_DAYS_HOURS_LEFT_IN_MEMBERSHIP", "$REMAINING_DAYS$ day(s) $REMAINING_HOURS$ hour(s) $REMAINING_MINUTES$ minutes(s) left in the membership")?.replace("$REMAINING_DAYS$", "0")?.replace("$REMAINING_HOURS$", trialPeriodData?.lastDayHours)?.replace("$REMAINING_MINUTES$", trialPeriodData?.lastMinutes)
        } else if (trialPeriodData?.daysRemaining > 0) {
            return getLangTranslation("SUBSCRIPTION_DAYS_HOURS_LEFT_IN_MEMBERSHIP", "$REMAINING_DAYS$ day(s) $REMAINING_HOURS$ hour(s) $REMAINING_MINUTES$ minutes(s) left in the membership")?.replace("$REMAINING_DAYS$", trialPeriodData?.daysRemaining)?.replace("$REMAINING_HOURS$", trialPeriodData?.lastDayHours)?.replace("$REMAINING_MINUTES$", trialPeriodData?.lastMinutes)
        } else {
            return getLangTranslation("SUBSCRIPTION_YOU_HAVE_USED_YOUR_TRIAL_PERIOD", "You have used your trial period")
        }
    }

    function isSubscriptionAvailable() {
        if (subscription && subscription !== 'DATA_NOT_FOUND') {
            return true;
        }
        return false;
    }

    function isSubscriptionExpired() {
        if (subscription && subscription !== 'DATA_NOT_FOUND' && subscription?.daysRemaining <= 0 && subscription?.lastDayHours <= 0 && subscription?.lastMinutes <= 0) {
            return true;
        }
        return false;
    }

    function isTrialPeriodAvailable() {
        if (trialPeriodData) {
            return true;
        }
        return false;
    }

    function isTrialPeriodExpired() {
        if (trialPeriodData?.daysRemaining <= 0 && trialPeriodData?.lastDayHours <= 0 && trialPeriodData?.lastMinutes <= 0) {
            return true;
        }
        return false;
    }

    function checkSubsciption() {
        if (isSubscriptionAvailable()) {
            if (isSubscriptionExpired()) {
                dispatch(setErrorInfo({
                    errorInfo: true,
                    title: "SUBSCRIPTION_EXPIRED_ERROR",
                    defaultTitle: "Your subscription is expired"
                }))
                return false;
            }
            return true;
        } else {
            if (isTrialPeriodAvailable()) {
                if (isTrialPeriodExpired()) {
                    dispatch(setErrorInfo({
                        errorInfo: true,
                        title: "SUBSCRIPTION_YOU_HAVE_USED_YOUR_TRIAL_PERIOD",
                        defaultTitle: "You have used your trial period"
                    }))
                    return false;
                }
                return true;
            }
        }
    }

    return {
        isSubscriptionExpired,
        noSubscriptionIsTrialPeriodExpired,
        isSubscriptionCardDetailLoding,
        getSubscriptionDetails,
        getTrialDataDetails,
        isSubscriptionAvailable,
        isSubscriptionExpired,
        isTrialPeriodAvailable,
        isTrialPeriodExpired,
        checkSubsciption
    }

}

export default useSubscription;